import { useEffect, useState } from "react";

export default function Toast({ message, duration = 2000, onClose }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(false), duration);
    return () => clearTimeout(timer);
  }, [duration]);

  return (
    <div
      style={{
        position: "fixed",
        bottom: "150px",
        left: "50%",
        transform: "translateX(-50%)",
        background: "rgb(163 162 162)",
        color: "rgb(47 47 47)",
        padding: "10px 20px",
        borderRadius: "8px",
        opacity: visible ? 1 : 0,
        transition: "opacity 1s ease",
        pointerEvents: "none",
        zIndex: 100000,
        fontWeight: "bold",
        width: "70%",
        border: "solid #2b2b2b 1px",
      }}
      onTransitionEnd={() => {
        if (!visible && onClose) onClose();
      }}
    >
      {message}
    </div>
  );
}
